import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { isToday } from 'date-fns';
import { debounceTime } from 'rxjs/operators';
import { Subject, Subscription } from 'rxjs';
import { CarregaJetta } from '../services/carrega_jetta/jetta.service';
import { MatDialog } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { ApiService } from 'src/app/services/contratos/contratos.service';

@Component({
    selector: 'app-carrega-jetta-interplantas',
    templateUrl: './carrega-jetta-interplantas.component.html',
    styleUrls: ['./carrega-jetta-interplantas.component.css'],
    standalone: false
})
export class CarregaJettaInterplantasComponent implements OnInit {

  items: any[] = [];
  sortColumn: string = '';
  user: string = 'luis.silva3@scania.com';
  senha: string = 'Meninas@3';
  sortNumber: number = 0;
  sortDirection: number = 1;
  dataLoaded = true;
    // Inicializa `startDate` para o primeiro dia do mês no formato 'yyyy-MM-dd'
    startDate: string = new Date(new Date().getFullYear(), new Date().getMonth(), 1)
    .toISOString()
    .split('T')[0];
  // endDate: string = new Date().toISOString().split('T')[0];
  endDate: string = new Date(new Date().setDate(new Date().getDate() + 1))
  .toISOString()
  .split('T')[0];

  filtroDataInicio: Date = new Date();
  filtroDataTermino: Date = new Date();
  itemsFiltrados: any[] = [];
  routes: any[] = [];
  searchText: string = '';
  items2: any[] = [ /* Seus itens aqui */];
  private searchTextSubject = new Subject<string>();
  private searchTextSubscription!: Subscription;
  urlConsulta: string = 'https://du0btsv8a3.execute-api.sa-east-1.amazonaws.com/dev22';
  urlAtualiza: string = 'https://uj88w4ga9i.execute-api.sa-east-1.amazonaws.com/dev12';
  data: any;
  dataArray: { [key: string]: string; }[] = [];
  query2: string = 'Itens_Jetta';
  queryCargasInterplantas: string = 'cargasInterplantasJetta';
  IDJetta: string = '';
  progressCounter: number = 0;
  isLoading: boolean = true;
  query3: string = 'tipos_Veiculos_Karrara';
  urlConsultaCompleta: string = 'https://fopq9ohj7e.execute-api.sa-east-1.amazonaws.com/v1';
  veiculos!: any[];
  trip_Json: {
    trip: {
      TransportType: string;
      Plate: string;
      cubage: string;
      cubage_M3: string;
      weightLoaded: string;
      weightLoaded_Kg: string;
      itensLoaded: string;
      link3d: string;
      ID: string;
      description: string;
      created: string;
      tableName: string;
      date: string;
    }[];
  } = {
      trip: [],
    };

  constructor(private carregaJetta: CarregaJetta, public dialog: MatDialog, private datePipe: DatePipe, private dynamoDBService: ApiService, private cdr: ChangeDetectorRef) { }

  async ngOnInit() {
    await this.getItemsFromJetta();
  }

  ngOnDestroy() {
    this.searchTextSubscription?.unsubscribe();
  }

  async geraJson() {
    for (let i = 0; i < this.items.length; i++) {
      const currentItem = this.items[i];
      try{
      await this.trip_Json.trip.push({
        TransportType: currentItem.result.transports[0].descricao,
        Plate: this.extrairPrimeirosSeteCaracteres(currentItem.description),
        cubage: currentItem.result.cubage,
        cubage_M3: currentItem.result.cubageLoaded,
        weightLoaded: currentItem.result.weight,
        weightLoaded_Kg: currentItem.result.weightLoaded,
        itensLoaded: currentItem.result.itemsLoaded,
        link3d: currentItem.result.link3d,
        ID: currentItem._id,
        description: currentItem.description,
        created: currentItem.date,
        tableName: this.queryCargasInterplantas,
        date: this.insereDate(currentItem)
      });
    }catch{
      console.log(currentItem.result)
    }
    }
    // this.dataArray = trip_Json
    // console.log(this.trip_Json)
  }

  insereDate(item: any){
    try{
      const texto = item.description.split(" ")[1];
      const parts = texto.split('/');
      // console.log(parts)
      const day = parseInt(parts[0], 10);
      // console.log(day)
      const month = parseInt(parts[1], 10) - 1;
      // console.log(month)
      const year = parseInt(parts[2], 10);
      // console.log(year)
      const date = new Date(year, month, day);
      console.log(date)
      return date.toISOString().split('T')[0];
    }catch{
      console.log(item.description)
      return "01/01/01 00:00"
    }
  }

  removerMultiplosDe24(stringHora: string): string {
    // Parse da string para obter as horas e os minutos
    const [horas, minutos] = stringHora.split(':').map(Number);
    // Conversão total para minutos
    const totalMinutos = horas * 60 + minutos;
    // Remoção de múltiplos de 24 horas
    const minutosSemMultiplos24 = totalMinutos % (24 * 60);
    // Conversão de volta para horas e minutos
    const horasResultantes = Math.floor(minutosSemMultiplos24 / 60);
    const minutosResultantes = minutosSemMultiplos24 % 60;
    // Formatação da nova hora
    const novaHora = `${horasResultantes.toString().padStart(2, '0')}:${minutosResultantes.toString().padStart(2, '0')}`;
    return novaHora;
  }

  extrairPrimeirosSeteCaracteres(texto: string): string {
    return texto.slice(0, 7);
  }

  formatarData(data: Date): string {
    const dia = String(data.getDate()).padStart(2, '0');
    const mes = String(data.getMonth() + 1).padStart(2, '0');
    const ano = data.getFullYear();
    return `${dia}/${mes}/${ano}`;
  }

  formatarData2(data: Date): string {
    const ano = data.getFullYear();
    const mes = (data.getMonth() + 1).toString().padStart(2, '0');
    const dia = data.getDate().toString().padStart(2, '0');
    const horas = data.getHours().toString().padStart(2, '0');
    const minutos = data.getMinutes().toString().padStart(2, '0');
    const segundos = data.getSeconds().toString().padStart(2, '0');
    const dataFormatada = `${ano}-${mes}-${dia}T${horas}:${minutos}:${segundos}.000Z`;
    return dataFormatada;
  }


  // async calcularMaiorValor() {
  //   // console.log("item")
  //   await this.filteredItems.forEach(async item => {     
  //     item.pesoLoaded = this.isValorValido(item['Weight Loaded']) ? ((item['Weight Loaded'] / item.capacidadePeso) * 100) : 0;
  //     item.cub = this.isValorValido(item.Cubage) ? ((item.Cubage / item.capacidadeVolumetrica) * 100) : 0;
  //     item.fillingRateMax = Math.max(item.pesoLoaded, item.cub)
  //     item.modeloValido = await this.veiculos.some(veic => veic.modelo == item['Transport Type']);
  //   });
  //   const valores = this.filteredItems.map(item => [item.pesoLoaded, item.cub]);
  //   // console.log(this.filteredItems)
  //   return Math.max(...valores.flat());
  // }

  isValorValido(value: any): boolean {
    return value != '' && value != null && value != undefined && value != 0;
  }

  async salvar() {
    this.isLoading = true;
    await this.geraJson();
    const itemsArray = this.trip_Json.trip.map(item => {
      // Remover as barras invertidas escapadas e garantir que os dados estejam no formato correto
      const itemsDataString = JSON.stringify(item).replace(/\\"/g, '"');
      return JSON.parse(itemsDataString) as { tableName: string, ID: string, acao: string };
    });
    // Divide o array em lotes de 25 itens
    const batches = await this.chunkArray(itemsArray, 25);
    // Envia cada lote em uma única requisição
    try {
      for (const batch of batches) {
        // console.log(batch)
        await this.dynamoDBService.salvar(batch, this.queryCargasInterplantas, this.urlAtualiza).toPromise();
      }
    } catch (error) {
      console.log(error);
    } finally {
      this.isLoading = false;
    }
  }

  getProgressWidth(): string {
    const totalItems = this.trip_Json.trip.length;
    const processedItems = this.progressCounter;
    const progressPercentage = (processedItems / totalItems) * 100;
    return `${progressPercentage}%`;
  }

  // Função para dividir o array em lotes de até 25 itens
  chunkArray(array: any[], size: number): any[][] {
    const results = [];
    for (let i = 0; i < array.length; i += size) {
      results.push(array.slice(i, i + size));
    }
    return results;
  }

  converterData(stringData: string): string {
    const partes = stringData.split('/');
    const dia = partes[0];
    const mes = partes[1];
    const ano = partes[2];

    return `${ano}-${mes}-${dia}`;
  }

  aplicarFiltroPorData(): void {
    if (this.filtroDataInicio && this.filtroDataTermino) {
      const filtroInicio = new Date(this.filtroDataInicio);
      const filtroTermino = new Date(this.filtroDataTermino);

      this.itemsFiltrados = this.items.filter(item => {
        const dataFormatada = this.converterData(item.ATA);
        const dataItem = new Date(dataFormatada);

        return dataItem >= filtroInicio && dataItem <= filtroTermino;
      });
    } else {
      this.itemsFiltrados = this.items;
    }
  }

  async getItemsFromJetta(): Promise<void> {
    console.log(this.startDate)
    console.log( this.endDate)
    this.isLoading = true;
    const filtro = 'Scheduled';
    (await this.carregaJetta.getCargaFechada(this.user, this.senha, this.startDate, this.endDate)).subscribe(
      (response: any) => {
        if (response.statusCode === 200) {
          try {
            const items = response.body.data;
            // console.log(items);
            if (Array.isArray(items)) {
              // this.items = items.map(item => ({ ...item, checked: false }));
              this.items = items;
              // //console.log(this.routes);
              this.isLoading = false;
            } else {
              console.error('Invalid items data:', items);
            }
          } catch (error) {
            console.error('Error parsing JSON:', error);
          }
        } else {
          console.error('Invalid response:', response);
        }
      },
      (error: any) => {
        console.error(error);
      }
    );
  }

}









